import { Alert, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

interface RevertToDraftDialogProps {
  open: boolean;
  isSaving: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
}

const RevertToDraftDialog = ({ open, isSaving, onClose, onConfirm, title = 'Edit Invoice?' }: RevertToDraftDialogProps) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" aria-labelledby="revert-dialog-title">
    <DialogTitle id="revert-dialog-title">
      <Typography variant="h4">{title}</Typography>
    </DialogTitle>
    <DialogContent>
      <Alert severity="warning">
        This action will revert the invoice to a <strong>Draft</strong> status, allowing it to be fully edited.
      </Alert>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button variant="contained" disabled={isSaving} onClick={onConfirm}>
        {isSaving ? <CircularProgress size={24} /> : 'Confirm & Revert'}
      </Button>
    </DialogActions>
  </Dialog>
);

export default RevertToDraftDialog;
